import { createFileRoute } from '@tanstack/react-router';
import { DiscountRulePage } from '@/features/rules/pages/rules-pages';

export const Route = createFileRoute('/_app/rules/discount')({ component: DiscountRulePage });
